module.exports = __webpack_public_path__ + "icon-mobx.NY9ZU3nw.svg";